import '@css/App.scss';
import Root, { loader as rootLoader } from '@routes/root';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { namespace } from '@utils/common';
import { initI18n } from '@utils/i18n';
import { publicApi, queryClient } from '@utils/remote';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { store } from './store';

const App = (props: { apiDomain: string; wstatic: string }) => {
    const container = document.querySelector('.app-container');
    if (!container) throw new Error('There is no container.');

    publicApi.defaults.baseURL = props.apiDomain;
    initI18n(props.wstatic);

    const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<Root />} loader={rootLoader} />));

    createRoot(container).render(
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

namespace('nc.tl.schedule');
window.nc.tl.schedule = App;
